import { Paper, Box, TextField, Typography, MenuItem } from "@mui/material";
import React, { useEffect } from "react";
import LoginSection from "../sections/LoginSection";
import { Context } from "../../App";
import { useState } from "react";

export default function TicketInfo({event, billet, setBillet, index}) {
    const { isConnected, setIsConnected } = React.useContext(Context);

    const [open, setOpen] = React.useState(false);

    return (
        <Paper sx={{ display: 'flex', flexDirection: 'column', minWidth: { xs: 'auto', sm: 400 }, borderRadius: 2, overflow: 'hidden' }}>
            <Box sx={{ px: 4, py: 2, backgroundColor: 'primary.main', color: 'white', mb: 2 }}>
                <Typography variant="h6" fontSize={{ xs: 18, sm: 'inherit' }} color="white">{event.titre} - {billet.tarif} - {billet.price?.toFixed(2)} €</Typography>
                <Typography variant="body1" color="grey" fontSize={16}>Participant #{index + 1}</Typography>
            </Box>
            <Box sx={{ px: 2 }}>
                <TextField fullWidth label="Nom" variant="outlined" value={billet.owner.nom} required sx={{ mb: 2 }} onChange={(e) => setBillet({ ...billet, owner: { ...billet.owner, nom: e.target.value } })} />
                <TextField fullWidth label="Prénom" variant="outlined" value={billet.owner.prenom} required sx={{ mb: 2 }} onChange={(e) => setBillet({ ...billet, owner: { ...billet.owner, prenom: e.target.value } })} />
            </Box>
        </Paper>

    )
    //  <Paper sx={{ display:'flex', flexDirection:'column', minWidth: '400px', borderRadius: 2, overflow: 'hidden' }}>
    //     <Box sx={{px:4, py:2, backgroundColor: 'primary.main', color: 'white', mb:2}}>
    //         <Typography variant="h6" color="white">{event.titre} - {billet.tarif} - {billet.price?.toFixed(2)} €</Typography>
    //         <Typography variant="body1" color="grey" fontSize={16}>Participant #{index+1}</Typography>
    //     </Box>

    //     <Box sx={{ px: 2 }}>
    //         <TextField fullWidth label="Nom" variant="outlined" value={billet.owner.nom} required sx={{ mb: 2 }}
    //         onChange={(e) => setBillet({...billet, owner: {...billet.owner, nom: e.target.value}})} />
    //         <TextField fullWidth label="Prénom" variant="outlined" value={billet.owner.prenom} required sx={{ mb: 2 }}
    //         onChange={(e) => setBillet({...billet, owner: {...billet.owner, prenom: e.target.value}})} />
    //     </Box>
        
    // </Paper>
}